/*
 * @Author: your name
 * @Date: 2021-03-04 16:20:57
 * @LastEditTime: 2026-03-04 17:19:11
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\assets\scripts\dateFormatting.js
 */
// ==========Date==========
// 将new Date() 里面的时间提取转化为YYYY/MM/DD格式输出
export function dateFormat(date, cut = '-') {
  let Y = date.getFullYear();
  let M = date.getMonth() + 1;
  let D = date.getDate();
  return `${Y}${cut}${M < 10 ? '0' + M : M}${cut}${D < 10 ? '0' + D : D}`;
}

export function dateFormatting(date, cut = '/') {
  let Y = date.getFullYear();
  let M = date.getMonth() + 1;
  let D = date.getDate();
  return `${Y}${cut}${M < 10 ? '0' + M : M}${cut}${D < 10 ? '0' + D : D}`;
}
// 将输入的日期字符串解析解析成Date对象
export function reDateFormatting(strDate) {
  strDate = strDate + ' ' + timeFormatting(new Date(), ':');
  let date = new Date(Date.parse(strDate.replace(/-/g, "/")));
  // console.log(date);
  return date;
}
// ==========Time==========
// 将new Date() 里面的时间提取转化为hh:mm:ss格式输出
export function timeFormatting(time, cut = ':') {
  let h = time.getHours();
  let m = time.getMinutes();
  let s = time.getSeconds();
  return `${h < 10 ? '0' + h : h}${cut}${m < 10 ? '0' + m : m}${cut}${s < 10 ? '0' + s : s}`;
}
// 将输入的时间字符串解析解析成Date对象
export function reTimeFormatting(strTime) {
  strTime = dateFormatting(new Date(), '-') + ' ' + strTime;
  let time = new Date(Date.parse(strTime.replace(/-/g, "/")));
  // console.log(time);
  return time;
}
// ==========Week==========
// 将选中的周转化为对应的八位二进制
export function weekFormatting(weeks) {
  // 有效星期 如0b1010010一共七位，从右住左数，第一位表示星期日，第二位星期一，第三位星期二，依此类推即星期一，四，六为有效星期
  // 输入=>weeks = ['一', '三', '五']输出=>42
  const weeksB = { '六': 64, '五': 32, '四': 16, '三': 8, '二': 4, '一': 2, '日': 1 };
  let weekSum = 0;
  weeks.forEach(ele => {
    weekSum += weeksB[ele];
  });
  return weekSum;
}
// 将输入的十进制转换周解析出来
export function reWeekFormatting(val) {
  // 有效星期 如0b1010010一共七位，从右住左数，第一位表示星期日，第二位星期一，第三位星期二，依此类推即星期一，四，六为有效星期
  const weeks = ['六', '五', '四', '三', '二', '一', '日'];
  let bit = parseInt(val).toString(2).toString();
  let bitArr = bit.split('');
  // 方法一
  // 转换为完整的七位周数组
  // while (bitArr.length < 7) {
  //   bitArr.unshift('0');
  // }
  // console.log(bitArr);
  // let selWeek = [];
  // bitArr.forEach((week, index) => {
  //   if (week === '1') {
  //     selWeek.push(weeks[index]);
  //   }
  // });
  // 方法二（性能更好）
  let selWeek = [];
  let bitArrL = bitArr.length;
  for (let i = 0; i < bitArrL; i++) {
    if (bitArr[bitArrL - i - 1] === '1') {
      selWeek.push(weeks[7 - 1 - i]);
    }
  }
  // console.log(selWeek);
  return selWeek;
}

export function getZoneTime(offset = 8) {
  // 取本地时间
  var localtime = new Date();
  // 取本地毫秒数
  var localmesc = localtime.getTime();
  // 取本地时区与格林尼治所在时区的偏差毫秒数
  var localOffset = localtime.getTimezoneOffset() * 60000;
  // 反推得到格林尼治时间
  var utc = localOffset + localmesc;
  // 得到指定时区时间
  var calctime = utc + (3600000 * offset);
  // 返回时区时间对象
  return new Date(calctime);
}

export function msFormatting(time) {
  let ms = Math.ceil(parseInt(time) / 1000);
  let H = Math.floor(ms / 60 / 60);
  let M = Math.floor(ms / 60) % 60;
  let S = ms % 60;
  return `${formatting(H)}:${formatting(M)}:${formatting(S)}`;
}

export function totalMilliseconds(str) {

  const [hours, minutes, seconds] = str.split(":").map(Number);

  const ms =
    hours * 60 * 60 * 1000 +   // 小时转毫秒
    minutes * 60 * 1000 +     // 分钟转毫秒
    seconds * 1000;           // 秒转毫秒

  return ms;
}

// 数据格式化
export function formatting(time, len = 2) {
  let strTime = time + '';
  while (strTime.length < len) {
    strTime = '0' + strTime
  }
  return strTime;
}


